<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch2">
<div class="chapterHead">
<p class="centerImage3"><img alt="image" src="images/ch2.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-2">You rush to the next room, expecting something exciting. But your mom is standing in front of a sundial. “Isn’t this wonderful?” she exclaims. “An exhibit on time!”</a></p><a id="pg-2">
<p class="para" style="text-indent: 5%;">Great, you think. A whole roomful of clocks! Boring!</p>
<p class="para" style="text-indent: 5%;">Then Denny gives you a karate kick in the back of the leg.</p>
<p class="para" style="text-indent: 5%;">“Ow!” you cry. “Stop it!”</p>
<p class="para" style="text-indent: 5%;">“You’re not the boss of me!” he says smugly.</p>
<p class="para" style="text-indent: 5%;">“Yes, I am!” you reply, punching him in the arm. He whines and complains to your parents. You can’t win!</p>
<p class="para" style="text-indent: 5%;">“I’m thirsty,” Denny says now. You can see he’s eaten almost half a bag of Gummi Bears in less than a minute.</p>
<p class="para" style="text-indent: 5%;">“Can you find a drinking fountain for Denny, dear?” your mom asks without taking her eyes off a grandfather clock.</p>
<p class="para" style="text-indent: 5%;">“Come on.” You grab Denny’s hand. But Denny pulls away and runs off down a hallway. You follow him. The hallway twists and turns. There’s no sign of either Denny or a water fountain. But near the end of the hall you see a sign on a door:</p>
<p class="paraCenter1" style="text-indent: 0%;"><span class="smallCaps">WARNING!</span></p>
<p class="paraCenter1" style="text-indent: 0%;"><span class="smallCaps">DANGEROUS EXPERIMENT INSIDE</span></p>
<p class="paraCenter1" style="text-indent: 0%;"><span class="smallCaps">THIS DOOR MUST BE KEPT LOCKED AT ALL TIMES</span></p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-2"><em class="italic">Go on to </em></a><a href="#/e9780545841016_ch003"><em class="italic">PAGE 3</em></a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841016_ch002.vue?02815b16